import { render, staticRenderFns } from "./StepFooter.vue?vue&type=template&id=38cddf54"
import script from "./StepFooter.vue?vue&type=script&lang=js"
export * from "./StepFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports